import React from 'react';

function About() {
  return (
    <div className="about-container">
      <h1 className="about-title">Về Chúng Tôi</h1>
      
      <div className="about-section">
        <h2>Kho Gạo Vinh Phước</h2>
        <p>
          Thành lập hơn 30 năm. Chúng tôi tự hào là đơn vị cung cấp gạo uy tín tại TP.HCM, 
          chuyên phục vụ cho các cơ sở sản xuất bún, phở và các sản phẩm từ gạo.
        </p>
      </div>

      <div className="about-section">
        <h2>Cam Kết Của Chúng Tôi</h2>
        <div className="core-values">
          <div className="value-item">
            <h3>Chất Lượng</h3>
            <p>Gạo chất lượng cao, đảm bảo vệ sinh an toàn thực phẩm</p>
          </div>
          <div className="value-item">
            <h3>Uy Tín</h3>
            <p>Đúng cam kết về chất lượng và số lượng</p>
          </div>
          <div className="value-item">
            <h3>Dịch Vụ</h3>
            <p>Giao hàng nhanh chóng, hỗ trợ đổi trả khi cần thiết</p>
          </div>
        </div>
      </div>

      <div className="about-section">
        <h2>Dịch Vụ</h2>
        <ul className="service-list">
          <li>Cung cấp gạo số lượng lớn cho cơ sở sản xuất</li>
          <li>Tư vấn chọn loại gạo phù hợp với sản phẩm</li>
          <li>Giao hàng tận nơi</li>
          <li>Hỗ trợ đổi trả nếu không đạt yêu cầu</li>
        </ul>
      </div>
    </div>
  );
}

export default About; 